export default __webpack_public_path__ + "static/media/vineyard.bff87206.png";